import {
    Box,
    Button,
    ButtonGroup,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Icon,
} from '@mui/material';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import React, { useEffect, useState } from 'react';
import AptaTable from 'examples/AptaTable';
import axios from 'axios';
import Swal from 'sweetalert2';
import { URL } from 'constants/constant';

const Scanner = () => {
    const [details, setDetails] = useState({ email: "" });
    const [open, setOpen] = useState(false);
    const [scanners, setScanners] = useState([]);
    const [roleType, setRoleType] = useState('add');

    const handleOpen = (type, item = { email: "", name: "", booth: "" }) => {
        setRoleType(type);
        setDetails(item);
        setOpen(true);
    };

    const handleClose = () => setOpen(false);

    const handleSave = async (data) => {
        try {
            if (roleType === 'add') {
                await axios.post(`${URL}/api/admin/scanner`, data);
                Swal.fire("Scanner added successfully!");
            } else {
                await axios.patch(`${URL}/api/admin/scanner/${data._id}`, data);
                Swal.fire("Scanner updated successfully!");
            }
            handleClose();
            getScanners();
        } catch (error) {
            handleClose();
            Swal.fire("An error occurred. Please try again.");
            console.error("Error saving scanner", error);
        }
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`${URL}/api/admin/scanner/${id}`);
            Swal.fire("Scanner deleted successfully!");
            getScanners();
        } catch (error) {
            console.error("Error deleting scanner", error);
        }
    };

    const getScanners = async () => {
        try {
            const res = await axios.get(`${URL}/api/admin/scanner`);
            if (res?.data) {
                setScanners(res.data?.data || []);
            }
        } catch (err) {
            console.error(err?.message);
        }
    };

    useEffect(() => {
        getScanners();
    }, []);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Box display="flex" justifyContent="end" mb={3}>
                <Button
                    startIcon={<Icon>add</Icon>}
                    style={{ color: 'white' }}
                    variant="contained"
                    color="primary"
                    onClick={() => handleOpen('add')}
                >
                    Add
                </Button>
            </Box>
            <AptaTable
                columns={['Name', 'Email', 'Booth', 'Actions']}
                rows={scanners?.map((item) => ({
                    Name: item?.name,
                    Email: item?.email,
                    Booth: item?.booth || 'NA',
                    Actions: (
                        <ButtonGroup size="small">
                            <Button color="info" onClick={() => handleOpen('edit', item)}>
                                <Icon color="info">edit</Icon>
                            </Button>
                            <Button color="error" onClick={() => handleDelete(item?._id)}>
                                <Icon color="error">delete</Icon>
                            </Button>
                        </ButtonGroup>
                    )
                }))}
            />
            <InputFormModal
                open={open}
                onClose={handleClose}
                onSave={handleSave}
                details={details}
                type={roleType}
            />
        </DashboardLayout>
    );
};

export default Scanner;

const InputFormModal = ({ open, onClose, onSave, details, type }) => {
    const [formData, setFormData] = useState({ email: "", name: "", password: "", booth: "" });

    useEffect(() => {
        if (details) {
            setFormData({ ...details, password: "" }); // Reset password to empty even in edit
        }
    }, [details]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSave = () => {
        const dataToSend = { ...formData };
        if (type === 'edit' && !dataToSend.password) {
            delete dataToSend.password; // Don't send empty password in edit
        }
        onSave(dataToSend);
    };

    const isDisabled =
        type === "add"
            ? !formData.email || !formData.name || !formData.password
            : !formData.email || !formData.name;

    return (
        <Dialog open={open} maxWidth="md" fullWidth onClose={onClose}>
            <DialogTitle>{type === 'add' ? 'Add Scanner' : 'Edit Scanner'}</DialogTitle>
            <DialogContent>
                <Box component="form" noValidate autoComplete="off">
                    <TextField
                        label="Name"
                        name="name"
                        type="text"
                        value={formData.name}
                        onChange={handleChange}
                        fullWidth
                        margin="normal"
                    />
                    <TextField
                        label="Email"
                        name="email"
                        type="email"
                        value={formData.email}
                        onChange={handleChange}
                        fullWidth
                        margin="normal"
                    />
                    <TextField
                        label="Password"
                        name="password"
                        type="password"
                        value={formData.password}
                        onChange={handleChange}
                        fullWidth
                        margin="normal"
                        placeholder={type === 'edit' ? 'Leave empty to keep existing password' : ''}
                    />
                    <TextField
                        label="Booth"
                        name="booth"
                        type="text"
                        value={formData.booth}
                        onChange={handleChange}
                        fullWidth
                        margin="normal"
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">Cancel</Button>
                <Button
                    onClick={handleSave}
                    color="primary"
                    variant="contained"
                    style={{ color: 'white' }}
                    disabled={isDisabled}
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

